const moment = require('moment');

function standardDateFormat(asOfDate: string) {
  return moment(asOfDate, ['YYYY-MM-DD', 'MM-DD-YYYY', 'DD-MM-YYYY']).format(
    'MM/DD/YYYY'
  );
}

export { standardDateFormat };
